module.exports = __webpack_public_path__ + "media/images/icons/outlined/info-ac8ae8e842b767dc0619b68e5186fa23.svg";